import React from "react";
import ForgetPasswordService from "./ForgetPasswordService";
import { NavLink } from "react-router-dom";
import { API_BASEURLICON } from "../../Config";

const ForgetPassword = () => {
  const imageUrl = API_BASEURLICON;
  const { input, handleChange, handleSubmit } = ForgetPasswordService();
  return (
    <>
      <div className="cus-wrapper">
        <div className="wrapper">
          <div className="title-text">
            <div className="title login cus-login-1">
              <img src={`${imageUrl}Image/Website/1/B2C-logo.png`} />
            </div>
          </div>
          <div className="form-container">
            <div className="form-inner">
              <form className="signup">
                <div className="field">
                  <input
                    type="text"
                    placeholder="Enter the mobile number"
                    name="UserID"
                    onChange={handleChange}
                    value={input?.UserID}
                  />
                </div>

                <div className="field btn">
                  <div className="btn-layer"></div>
                  <button type="button" onClick={handleSubmit}>
                    Generate
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
